
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'feedback-public-submission-ui',
  currentProjectVersion: 'static-1.30629',
  depVersions: {
  "feedback-public-submission-ui": "static-1.30629",
  "emoji-mart": "static-3.4",
  "feedback-schema": "static-1.55108",
  "head-dlb": "static-1.5007",
  "hs-test-utils": "static-1.8213",
  "hubspot-dlb": "static-2.1854",
  "HubStyleTokens": "static-2.11666",
  "I18n": "static-7.1648",
  "quartz": "static-1.7284",
  "quartz-config": "static-1.1062",
  "quartz-core": "static-1.6503",
  "react-dlb": "static-1.83",
  "react-dnd": "static-4.51",
  "react-dnd-html5-backend": "static-2.10",
  "redux-mock-store": "static-1.8",
  "redux-thunk": "static-2.43",
  "reselect": "static-3.8",
  "sinon": "static-1.9",
  "tinymce": "static-6.5",
  "cssUtils": "static-1.846",
  "enviro": "static-4.455",
  "feedback-shared-ui": "static-1.55095",
  "feedback-utils": "static-1.55099",
  "forms-embed-utils-lib": "static-1.4656",
  "forms-utils-lib": "static-1.12927",
  "foundations-assets": "static-1.5066",
  "foundations-components": "static-1.8297",
  "foundations-theming": "static-1.4630",
  "hub-http": "static-1.6409",
  "hubspot-url-utils": "static-1.4132",
  "HubStyle": "static-2.11973",
  "icons": "static-2.667",
  "immutable": "static-2.79",
  "quick-fetch": "static-1.4051",
  "raven": "static-3.5925",
  "react": "static-7.189",
  "react-dom": "static-7.85",
  "react-input-autosize": "static-2.17",
  "react-redux": "static-7.71",
  "react-rhumb": "static-1-aeastham-base-reporter-resolved-tracking.3",
  "react-select-plus": "static-1.108",
  "react-utils": "static-2.5474",
  "react-virtualized": "static-2.102",
  "redux": "static-4.16",
  "StyleGuideUI": "static-3.491",
  "tinymce-plugins": "static-1.57996",
  "transmute": "static-2.85",
  "ui-images": "static-2.1209",
  "UIComponents": "static-3.8612",
  "hs-promise-rejection-tracking": "static-1.5587",
  "PortalIdParser": "static-2.404",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "metrics-js": "static-1.9637",
  "styled-components": "static-2.89",
  "bend-plugin-trellis-migration": "static-1.3533",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.3561",
  "quartz-webpack": "static-1.3508",
  "foundations-theming-specialty": "static-1.2346",
  "property-description-translator": "static-1.4029",
  "HeadJS": "static-2.779",
  "framer-motion": "static-1.75",
  "hs-test-utils-bend-plugin": "static-1.3324",
  "msw": "static-1.39",
  "testing-library": "static-1.155",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.225",
  "moment-timezone": "static-5.86",
  "jasmine": "static-4.4514",
  "jasmine-runner": "static-1.6646",
  "dispatcher": "static-1.140",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.855",
  "hubspotter-http": "static-1.4784",
  "mobile-manifest-mixins": "static-1.553",
  "module-federation": "static-1.29",
  "quartz-auth": "static-1.959",
  "quartz-head": "static-1.949",
  "quartz-i18n": "static-1.959",
  "quartz-routing": "static-1.714",
  "quartz-test": "static-1.959",
  "quartz-tracking": "static-1.663",
  "trellis-components": "static-1.2330",
  "ui-fonts": "static-1.928",
  "usage-tracker-container": "static-1-session-replay-endpoint-migration.3",
  "usage-tracker-core": "static-1-session-replay-endpoint-migration.3",
  "hs-lodash": "static-4.45",
  "sassPrefix": "static-1.160",
  "conversations-skeleton-state": "static-1.7438",
  "reference-resolvers": "static-1.8367",
  "sanitize-text": "static-1.8337",
  "PatternValidationJS": "static-1-add-latest-to-version-tag.2",
  "ReduxMessenger": "static-2.10556",
  "sanitize": "static-1.4668",
  "outpost": "static-1.4357",
  "rpc-client-utils": "static-1.4849",
  "underscore": "static-1.8",
  "bend-plugin-foundations-components": "static-1.4566",
  "floating-ui": "static-1.60",
  "hs-story-utils": "static-1.9617",
  "react-aria": "static-1.69",
  "react-create-root-preference": "static-1.48",
  "tanstack-table": "static-1.58",
  "trellis-assets": "static-1.2311",
  "bend-plugin-foundations-theming": "static-1.3113",
  "foundations-theming-base": "static-1.3615",
  "stylex": "static-1.37",
  "hs-locale-management": "static-1.214",
  "csstype": "static-1.50",
  "web-vitals": "static-1.9",
  "ai-components-ui-library": "static-1.9444",
  "atom": "static-1.5267",
  "codemirror": "static-5.98",
  "content-assistance-lib": "static-1.8042",
  "ContentUtils": "static-1.68928",
  "data-token-picker": "static-1.16736",
  "file-manager-components": "static-1.24186",
  "FileManagerCore": "static-1.39685",
  "FileManagerLib": "static-1.39826",
  "frontend-preferences-client": "static-1.8118",
  "hub-http-contrib": "static-1.3232",
  "interframe": "static-3.4946",
  "layout-dnd-components": "static-1.12807",
  "layout-dnd-utils": "static-1.11782",
  "property-translator": "static-1.5585",
  "react-codemirror": "static-1.10828",
  "react-colorpicker": "static-2.10400",
  "reference-resolvers-lite": "static-1.8288",
  "rich-text-lib": "static-1.20156",
  "tinymce-data": "static-1.40967",
  "tinymce-themes": "static-1.56852",
  "ui-addon-emoji-picker": "static-1.10076",
  "ui-addon-sales-email": "static-1.5403",
  "ui-brand-identity-lib": "static-1.15994",
  "bender-build-tools": "static-1.3316",
  "hub-http-shared-msw-handlers": "static-1.10424",
  "hubspotter-http-shared-msw-handlers": "static-1.10422",
  "usage-tracker-session-replay": "static-1-session-replay-endpoint-migration.3",
  "base-ui": "static-1.17",
  "react-day-picker": "static-1.6",
  "trellis-theming": "static-1.1139",
  "tanstack-virtual": "static-1.33",
  "autolinker": "static-3.11",
  "bend-plugin-chirp-manifest": "static-1.259",
  "chirp-fetch": "static-1.2078",
  "chatspot-core": "static-1.22284",
  "copilot-toolkit": "static-1.11628",
  "customer-data-objects-ui-components": "static-1.13223",
  "data-fetching-client": "static-1.9849",
  "diff-match-patch": "static-1.7",
  "superstore": "static-1.4950",
  "ui-addon-video-player": "static-1.8897",
  "ui-coaching-tips": "static-1.29100",
  "usage-tracker": "static-1-session-replay-endpoint-migration.3",
  "cms-field-types": "static-1.5006",
  "content-icons-ui": "static-1.2282",
  "integrations-lib": "static-1.16764",
  "customer-data-objects": "static-1.7871",
  "apollo-dlb": "static-3.86",
  "breeze-engine-lib": "static-1.1405",
  "apollo-link-hub-http": "static-2.4844",
  "apollo-stack-hubspot": "static-3.89",
  "graphql": "static-1.85",
  "immer": "static-1.33",
  "immerable": "static-1.4338",
  "ui-addon-iframeable": "static-1.9267",
  "video-components-external": "static-1.11904",
  "video-data-lib": "static-1.35562",
  "audio-components": "static-1.6196",
  "cropperjs": "static-1.10",
  "feedback-loader": "static-1.29646",
  "FileManagerImages": "static-1.37337",
  "foundations-components-legacy": "static-1.1322",
  "html-to-image": "static-1.57",
  "react-immutable-proptypes": "static-2.8",
  "redux-toolkit": "static-1.7",
  "salesImages": "static-1.529",
  "ui-universal-auth": "static-1.9205",
  "urlinator": "static-1.4723",
  "video-components": "static-1.13906",
  "video-embed": "static-1.36396",
  "ts-schema": "static-1.4213",
  "ContentData": "static-1.69003",
  "layout-data-lib": "static-1.10107",
  "react-dnd-compat": "static-1.4806",
  "browser-eslint": "static-2.57",
  "batch-promise": "static-1.1735",
  "external-options-client-types": "static-1.4259",
  "fast-json-stable-stringify": "static-1.4",
  "framework-data-schema-resolvers": "static-1.7085",
  "hs-promise-utils": "static-1.5784",
  "inbound-db-properties-service-client": "static-1.3978",
  "NamespacedHubStyle": "static-2.9184",
  "growth-onboarding-confetti": "static-1.3252",
  "SharedI18nStrings": "static-1.182",
  "ui-addon-i18n": "static-1.11338",
  "amplitude-session-replay-browser": "static-1.60",
  "markdown-it": "static-1.6",
  "magpie-lib": "static-1.5684",
  "magpie-types": "static-1.5144",
  "simple-logging-lib": "static-1.3240",
  "avatar-components": "static-1.2689",
  "customer-data-ui-utilities": "static-1.10016",
  "growth-onboarding-feedback-components": "static-1.6772",
  "flux-actions": "static-1.354",
  "hubspot-apollo-client": "static-1.5068",
  "integrations-error-boundary-lib": "static-1.14179",
  "integrations-tracking-lib": "static-1.5798",
  "laboratory-lib": "static-3.7343",
  "native-integrations-shared-strings": "static-1.7969",
  "redux-observable": "static-1.11",
  "rxjs": "static-5.10",
  "ui-shepherd-react": "static-3.10453",
  "unified-auth": "static-1.719",
  "breeze-engine-core": "static-1.683",
  "ably": "static-2.2",
  "highlight.js": "static-1.82",
  "navigation-messaging": "static-1.7872",
  "content-media-composition-data-lib": "static-1.12934",
  "content-media-compositions": "static-2.16941",
  "idb-keyval": "static-1.47",
  "media-bridge-lib": "static-1.19254",
  "unified-auth-core-lib": "static-1.1001",
  "social-insights-client-types": "static-1.22580",
  "advanced-menus-core": "static-1.15437",
  "advanced-menus-lib": "static-1.12331",
  "ExportDialog": "static-6.10571",
  "ui-memberships-settings-lib": "static-1.34580",
  "conditional-properties-service-client": "static-1.3930",
  "crm-pipelines-api-client-types": "static-1.4271",
  "fdsr-migration-layer": "static-1.204",
  "framework-builder-read-service-client": "static-1.4139",
  "framework-data-schema-quick-fetch": "static-1.6990",
  "inbound-db-meta-service-client": "static-1.3718",
  "multi-currency-client-types": "static-1.3824",
  "persist-promise": "static-1.3892",
  "foundations-components-test-utils": "static-1.5780",
  "reactive-lib": "static-1.913",
  "react-immutable-render-mixin": "static-1.9",
  "hubspot-apollo-cache": "static-1.527",
  "universal-page-editor-lib": "static-1.3202",
  "adobe-sign-auth-lib": "static-1.242",
  "ads-unified-auth-lib": "static-1.744",
  "google-sheets-integration-lib": "static-1.809",
  "microsoft-drive-integration-lib": "static-1.915",
  "surveymonkey-integration-lib": "static-1.256",
  "slack-ui-library": "static-1.10589",
  "js-cookie": "static-1.18",
  "fsm": "static-1.3923",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15436",
  "simple-menus-lib": "static-1.16953",
  "crm-record-cards-service-types": "static-1.3717",
  "location-customization-utils-lib": "static-1.9844",
  "react-flip-move": "static-1.74"
},
  depPathPrefixes: {
  "feedback-public-submission-ui": "/feedback-public-submission-ui/static-1.30629",
  "emoji-mart": "/emoji-mart/static-3.4",
  "feedback-schema": "/feedback-schema/static-1.55108",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-test-utils": "/hs-test-utils/static-1.8213",
  "hubspot-dlb": "/hubspot-dlb/static-2.1854",
  "HubStyleTokens": "/HubStyleTokens/static-2.11666",
  "I18n": "/I18n/static-7.1648",
  "quartz": "/quartz/static-1.7284",
  "quartz-config": "/quartz-config/static-1.1062",
  "quartz-core": "/quartz-core/static-1.6503",
  "react-dlb": "/react-dlb/static-1.83",
  "react-dnd": "/react-dnd/static-4.51",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-2.10",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-thunk": "/redux-thunk/static-2.43",
  "reselect": "/reselect/static-3.8",
  "sinon": "/sinon/static-1.9",
  "tinymce": "/tinymce/static-6.5",
  "cssUtils": "/cssUtils/static-1.846",
  "enviro": "/enviro/static-4.455",
  "feedback-shared-ui": "/feedback-shared-ui/static-1.55095",
  "feedback-utils": "/feedback-utils/static-1.55099",
  "forms-embed-utils-lib": "/forms-embed-utils-lib/static-1.4656",
  "forms-utils-lib": "/forms-utils-lib/static-1.12927",
  "foundations-assets": "/foundations-assets/static-1.5066",
  "foundations-components": "/foundations-components/static-1.8297",
  "foundations-theming": "/foundations-theming/static-1.4630",
  "hub-http": "/hub-http/static-1.6409",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4132",
  "HubStyle": "/HubStyle/static-2.11973",
  "icons": "/icons/static-2.667",
  "immutable": "/immutable/static-2.79",
  "quick-fetch": "/quick-fetch/static-1.4051",
  "raven": "/raven/static-3.5925",
  "react": "/react/static-7.189",
  "react-dom": "/react-dom/static-7.85",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-redux": "/react-redux/static-7.71",
  "react-rhumb": "/react-rhumb/static-1-aeastham-base-reporter-resolved-tracking.3",
  "react-select-plus": "/react-select-plus/static-1.108",
  "react-utils": "/react-utils/static-2.5474",
  "react-virtualized": "/react-virtualized/static-2.102",
  "redux": "/redux/static-4.16",
  "StyleGuideUI": "/StyleGuideUI/static-3.491",
  "tinymce-plugins": "/tinymce-plugins/static-1.57996",
  "transmute": "/transmute/static-2.85",
  "ui-images": "/ui-images/static-2.1209",
  "UIComponents": "/UIComponents/static-3.8612",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "metrics-js": "/metrics-js/static-1.9637",
  "styled-components": "/styled-components/static-2.89",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3533",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3561",
  "quartz-webpack": "/quartz-webpack/static-1.3508",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2346",
  "property-description-translator": "/property-description-translator/static-1.4029",
  "HeadJS": "/HeadJS/static-2.779",
  "framer-motion": "/framer-motion/static-1.75",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3324",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.155",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.225",
  "moment-timezone": "/moment-timezone/static-5.86",
  "jasmine": "/jasmine/static-4.4514",
  "jasmine-runner": "/jasmine-runner/static-1.6646",
  "dispatcher": "/dispatcher/static-1.140",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.855",
  "hubspotter-http": "/hubspotter-http/static-1.4784",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.553",
  "module-federation": "/module-federation/static-1.29",
  "quartz-auth": "/quartz-auth/static-1.959",
  "quartz-head": "/quartz-head/static-1.949",
  "quartz-i18n": "/quartz-i18n/static-1.959",
  "quartz-routing": "/quartz-routing/static-1.714",
  "quartz-test": "/quartz-test/static-1.959",
  "quartz-tracking": "/quartz-tracking/static-1.663",
  "trellis-components": "/trellis-components/static-1.2330",
  "ui-fonts": "/ui-fonts/static-1.928",
  "usage-tracker-container": "/usage-tracker-container/static-1-session-replay-endpoint-migration.3",
  "usage-tracker-core": "/usage-tracker-core/static-1-session-replay-endpoint-migration.3",
  "hs-lodash": "/hs-lodash/static-4.45",
  "sassPrefix": "/sassPrefix/static-1.160",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7438",
  "reference-resolvers": "/reference-resolvers/static-1.8367",
  "sanitize-text": "/sanitize-text/static-1.8337",
  "PatternValidationJS": "/PatternValidationJS/static-1-add-latest-to-version-tag.2",
  "ReduxMessenger": "/ReduxMessenger/static-2.10556",
  "sanitize": "/sanitize/static-1.4668",
  "outpost": "/outpost/static-1.4357",
  "rpc-client-utils": "/rpc-client-utils/static-1.4849",
  "underscore": "/underscore/static-1.8",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4566",
  "floating-ui": "/floating-ui/static-1.60",
  "hs-story-utils": "/hs-story-utils/static-1.9617",
  "react-aria": "/react-aria/static-1.69",
  "react-create-root-preference": "/react-create-root-preference/static-1.48",
  "tanstack-table": "/tanstack-table/static-1.58",
  "trellis-assets": "/trellis-assets/static-1.2311",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3113",
  "foundations-theming-base": "/foundations-theming-base/static-1.3615",
  "stylex": "/stylex/static-1.37",
  "hs-locale-management": "/hs-locale-management/static-1.214",
  "csstype": "/csstype/static-1.50",
  "web-vitals": "/web-vitals/static-1.9",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9444",
  "atom": "/atom/static-1.5267",
  "codemirror": "/codemirror/static-5.98",
  "content-assistance-lib": "/content-assistance-lib/static-1.8042",
  "ContentUtils": "/ContentUtils/static-1.68928",
  "data-token-picker": "/data-token-picker/static-1.16736",
  "file-manager-components": "/file-manager-components/static-1.24186",
  "FileManagerCore": "/FileManagerCore/static-1.39685",
  "FileManagerLib": "/FileManagerLib/static-1.39826",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8118",
  "hub-http-contrib": "/hub-http-contrib/static-1.3232",
  "interframe": "/interframe/static-3.4946",
  "layout-dnd-components": "/layout-dnd-components/static-1.12807",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11782",
  "property-translator": "/property-translator/static-1.5585",
  "react-codemirror": "/react-codemirror/static-1.10828",
  "react-colorpicker": "/react-colorpicker/static-2.10400",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8288",
  "rich-text-lib": "/rich-text-lib/static-1.20156",
  "tinymce-data": "/tinymce-data/static-1.40967",
  "tinymce-themes": "/tinymce-themes/static-1.56852",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10076",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5403",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.15994",
  "bender-build-tools": "/bender-build-tools/static-1.3316",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10424",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10422",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1-session-replay-endpoint-migration.3",
  "base-ui": "/base-ui/static-1.17",
  "react-day-picker": "/react-day-picker/static-1.6",
  "trellis-theming": "/trellis-theming/static-1.1139",
  "tanstack-virtual": "/tanstack-virtual/static-1.33",
  "autolinker": "/autolinker/static-3.11",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.259",
  "chirp-fetch": "/chirp-fetch/static-1.2078",
  "chatspot-core": "/chatspot-core/static-1.22284",
  "copilot-toolkit": "/copilot-toolkit/static-1.11628",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13223",
  "data-fetching-client": "/data-fetching-client/static-1.9849",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "superstore": "/superstore/static-1.4950",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8897",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29100",
  "usage-tracker": "/usage-tracker/static-1-session-replay-endpoint-migration.3",
  "cms-field-types": "/cms-field-types/static-1.5006",
  "content-icons-ui": "/content-icons-ui/static-1.2282",
  "integrations-lib": "/integrations-lib/static-1.16764",
  "customer-data-objects": "/customer-data-objects/static-1.7871",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.1405",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4844",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.89",
  "graphql": "/graphql/static-1.85",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.4338",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9267",
  "video-components-external": "/video-components-external/static-1.11904",
  "video-data-lib": "/video-data-lib/static-1.35562",
  "audio-components": "/audio-components/static-1.6196",
  "cropperjs": "/cropperjs/static-1.10",
  "feedback-loader": "/feedback-loader/static-1.29646",
  "FileManagerImages": "/FileManagerImages/static-1.37337",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1322",
  "html-to-image": "/html-to-image/static-1.57",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "salesImages": "/salesImages/static-1.529",
  "ui-universal-auth": "/ui-universal-auth/static-1.9205",
  "urlinator": "/urlinator/static-1.4723",
  "video-components": "/video-components/static-1.13906",
  "video-embed": "/video-embed/static-1.36396",
  "ts-schema": "/ts-schema/static-1.4213",
  "ContentData": "/ContentData/static-1.69003",
  "layout-data-lib": "/layout-data-lib/static-1.10107",
  "react-dnd-compat": "/react-dnd-compat/static-1.4806",
  "browser-eslint": "/browser-eslint/static-2.57",
  "batch-promise": "/batch-promise/static-1.1735",
  "external-options-client-types": "/external-options-client-types/static-1.4259",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7085",
  "hs-promise-utils": "/hs-promise-utils/static-1.5784",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3978",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9184",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3252",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11338",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "markdown-it": "/markdown-it/static-1.6",
  "magpie-lib": "/magpie-lib/static-1.5684",
  "magpie-types": "/magpie-types/static-1.5144",
  "simple-logging-lib": "/simple-logging-lib/static-1.3240",
  "avatar-components": "/avatar-components/static-1.2689",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10016",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6772",
  "flux-actions": "/flux-actions/static-1.354",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5068",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14179",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5798",
  "laboratory-lib": "/laboratory-lib/static-3.7343",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7969",
  "redux-observable": "/redux-observable/static-1.11",
  "rxjs": "/rxjs/static-5.10",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10453",
  "unified-auth": "/unified-auth/static-1.719",
  "breeze-engine-core": "/breeze-engine-core/static-1.683",
  "ably": "/ably/static-2.2",
  "highlight.js": "/highlight.js/static-1.82",
  "navigation-messaging": "/navigation-messaging/static-1.7872",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.12934",
  "content-media-compositions": "/content-media-compositions/static-2.16941",
  "idb-keyval": "/idb-keyval/static-1.47",
  "media-bridge-lib": "/media-bridge-lib/static-1.19254",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1001",
  "social-insights-client-types": "/social-insights-client-types/static-1.22580",
  "advanced-menus-core": "/advanced-menus-core/static-1.15437",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12331",
  "ExportDialog": "/ExportDialog/static-6.10571",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34580",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3930",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4271",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.204",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4139",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6990",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3718",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3824",
  "persist-promise": "/persist-promise/static-1.3892",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5780",
  "reactive-lib": "/reactive-lib/static-1.913",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.527",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3202",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.242",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.744",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.809",
  "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.915",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.256",
  "slack-ui-library": "/slack-ui-library/static-1.10589",
  "js-cookie": "/js-cookie/static-1.18",
  "fsm": "/fsm/static-1.3923",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15436",
  "simple-menus-lib": "/simple-menus-lib/static-1.16953",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3717",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9844",
  "react-flip-move": "/react-flip-move/static-1.74"
}
};
